/** @format */

import React from 'react';
import { connect } from 'react-redux';
import CasesManagerStatusPres from 'src/ui/features/Cases/presentational/CasesManagerStatusPres';
import { setCaseManagerStatus } from 'src/services/cases.service';

class CasesFrequencyContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      caseStatusId: props.caseStatusId,
      reasonForStatusChange: props.reasonForStatusChange,
      isError: false,
      disableUpdate: false,
    };
  }

  handleCaseStatusChange = caseStatusId => {
    this.setState({ caseStatusId: caseStatusId, isError: false });
  };

  handleOtherReasonChange = reasonForStatusChange => {
    this.setState({ reasonForStatusChange: reasonForStatusChange, isError: false });
  };

  handleUpdate = async () => {
    this.setState({ disableUpdate: true });
    const { onRefreshDetails, caseManagerId } = this.props;
    let { caseStatusId, reasonForStatusChange } = this.state;
    if (caseStatusId === 3 && (reasonForStatusChange === null || reasonForStatusChange.length == 0)) {
      this.setState({ isError: true, disableUpdate: false });
      return;
    }

    if (caseStatusId !== 3) {
      this.setState({ isError: false, reasonForStatusChange: '' });
      reasonForStatusChange = '';
    }

    const result = await setCaseManagerStatus(caseManagerId, caseStatusId, reasonForStatusChange);

    if (result && result.success) {
      if (onRefreshDetails) await onRefreshDetails();
    }
    this.setState({ disableUpdate: false });
  };

  render() {
    return (
      <CasesManagerStatusPres
        caseStatusId={this.state.caseStatusId}
        statusList={this.props.statusList}
        reasonForStatusChange={this.state.reasonForStatusChange}
        handleCaseStatusChange={this.handleCaseStatusChange}
        handleOtherReasonChange={this.handleOtherReasonChange}
        onUpdate={this.handleUpdate}
        isError={this.state.isError}
        disableUpdate={this.state.disableUpdate}
      />
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CasesFrequencyContainer);



// WEBPACK FOOTER //
// ./src/ui/features/Cases/containers/CasesManagerStatusContainer.js